export const ENDPOINT_MESSAGE_ASK_TO_SET_META = 'flip/ask-to-set-meta';
